import { useState, useEffect, useCallback } from 'react';

// waiting time beyond this is a KPI fail (red indicator)
const WAIT_KPI_FAIL_MINUTES = 20;

const getIndicatorColor = (diffMs) => {
    const minutes = diffMs / 60000;
    if (minutes < 15) return '#22c55e';
    if (minutes <= WAIT_KPI_FAIL_MINUTES) return '#f97316';
    return '#ef4444';
};

const isWaitKpiFailing = (diffMs) => diffMs / 60000 > WAIT_KPI_FAIL_MINUTES;

const formatElapsed = (ms) => {
    if (ms <= 0) return '0s';
    const totalSecs = Math.floor(ms / 1000);
    const hours = Math.floor(totalSecs / 3600);
    const minutes = Math.floor((totalSecs % 3600) / 60);
    const seconds = totalSecs % 60;

    if (hours > 0) return `${hours}h ${minutes}m ${seconds}s`;
    if (minutes > 0) return `${minutes}m ${seconds}s`;
    return `${seconds}s`;
};

// kpi=false shows the time without the KPI colours (e.g. ALT pickups, which have no waiting-time KPI)
const ElapsedTime = ({ since, frozenAt, style, prefix = '', kpi = true }) => {
    const [elapsed, setElapsed] = useState('');
    const [diffMs, setDiffMs] = useState(0);

    const calculate = useCallback(() => {
        if (!since) return { text: '', ms: 0 };

        const endPoint = frozenAt ? new Date(frozenAt).getTime() : Date.now();
        const ms = endPoint - new Date(since).getTime();
        return { text: formatElapsed(ms), ms: Math.max(ms, 0) };
    }, [since, frozenAt]);

    useEffect(() => {
        if (!since) return;

        const update = () => {
            const result = calculate();
            setElapsed(result.text);
            setDiffMs(result.ms);
        };

        update();
        if (frozenAt) return;
        const interval = setInterval(update, 1000);
        return () => clearInterval(interval);
    }, [since, frozenAt, calculate]);

    if (!since) return <span style={style}>-</span>;

    const color = kpi ? getIndicatorColor(diffMs) : '#9ca3af';

    return (
        <span title={frozenAt ? "Check-in time paused" : "Time elapsed since passenger checked in"} style={{ display: 'inline-flex', alignItems: 'center', gap: 5, color, cursor: 'default', ...style }}>
            <span style={{
                width: 8,
                height: 8,
                borderRadius: '50%',
                backgroundColor: color,
                flexShrink: 0,
            }} />
            {prefix}{elapsed}
        </span>
    );
};

export { getIndicatorColor, isWaitKpiFailing };
export default ElapsedTime;
